import useWindowDimensions from "./useWindowDimensions";

const useIsTablet = () => {
  const { height: _height, width } = useWindowDimensions();
  return width <= 992;
};


export default useIsTablet;
